import { render, staticRenderFns } from "./myApproveListYet.vue?vue&type=template&id=1298f9af&scoped=true&"
import script from "./myApproveListYet.vue?vue&type=script&lang=js&"
export * from "./myApproveListYet.vue?vue&type=script&lang=js&"
import style0 from "./myApproveListYet.vue?vue&type=style&index=0&id=1298f9af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298f9af",
  null
  
)

export default component.exports